import React, { useEffect, useState } from 'react';

/** 새 화면 알림(P2c 3걸음 · 공명5 · 규칙이 바뀌기 前 학생들이 새 화면을 받게) — 5분마다 /index.html 의 진입 묶음(index-*.js)을 보고
 *  지금 실은 것과 다르면 위쪽 띠 「새 화면이 나왔습니다 · 새로 고침」. 에뮬 · 개발에선 쉼. */
const entryOf = (html: string) => (html.match(/\/assets\/index-[A-Za-z0-9_-]+\.js/) || [])[0] || '';
const loaded = () => {
  const s = Array.from(document.querySelectorAll('script[src]')).map((x) => (x as HTMLScriptElement).src).find((src) => /\/assets\/index-[A-Za-z0-9_-]+\.js/.test(src)) || '';
  return entryOf(s);
};

const VersionBanner: React.FC = () => {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    if (import.meta.env.DEV || import.meta.env.VITE_USE_EMULATOR === '1') return undefined;
    const mine = loaded();
    if (!mine) return undefined;
    let off = false;
    const check = async () => {
      try {
        const r = await fetch(`/index.html?v=${Date.now()}`, { cache: 'no-store' });
        if (!r.ok) return;
        const live = entryOf(await r.text());
        if (!off && live && live !== mine) setStale(true);
      } catch { /* 망 끊김 — 다음에 */ }
    };
    const t = window.setInterval(check, 5 * 60 * 1000);
    const vis = () => { if (document.visibilityState === 'visible') void check(); };
    document.addEventListener('visibilitychange', vis);
    return () => { off = true; window.clearInterval(t); document.removeEventListener('visibilitychange', vis); };
  }, []);
  if (!stale) return null;
  return (
    <div role="status" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999, display: 'flex', gap: 12, alignItems: 'center', justifyContent: 'center', padding: '10px 16px', background: '#1E3A8A', color: '#fff', fontSize: 14, fontWeight: 700 }}>
      <span>새 화면이 나왔습니다</span>
      <button type="button" onClick={() => window.location.reload()} style={{ padding: '6px 14px', borderRadius: 8, background: '#fff', color: '#1E3A8A', fontWeight: 800 }}>새로 고침</button>
    </div>
  );
};
export default VersionBanner;
